import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="13" height="13" rx="6.5" stroke="white" />
    <path
      d="M2 7C2 7.98891 2.29324 8.95561 2.84265 9.77785C3.39206 10.6001 4.17295 11.241 5.08658 11.6194C6.00021 11.9978 7.00555 12.0969 7.97545 11.9039C8.94536 11.711 9.83627 11.2348 10.5355 10.5355C11.2348 9.83627 11.711 8.94536 11.9039 7.97545C12.0969 7.00555 11.9978 6.00021 11.6194 5.08658C11.241 4.17295 10.6001 3.39206 9.77785 2.84265C8.95561 2.29325 7.98891 2 7 2L7 7L2 7Z"
      fill="white"
    />
  </svg>
);

export default SVG;
